import React from 'react';
import HeaderAndError from '../../../commons/form-fields/HeaderAndError';
import { trueFalseOptions } from '../../OnboardingConstants';
import GenericToggleButtonGroupField from '../../../commons/form-fields/GenericToggleButtonGroupField';
import { BoardMembershipOrganisationSection } from './BoardMembershipOrganisationSection';

export const BoardMembershipInfoFormSection = () => (
    <div className="max-w-4xl mx-auto bg-white px-6 py-1 md:mt-3 md:mb-6 rounded shadow-md text-sm">
        <HeaderAndError label="Board Memberships" />
        <GenericToggleButtonGroupField
            name="info.resume.isBoardMember"
            inlineLabel={
                'At any time during the past two years, have you served on the board of directors or ' +
                'board of trustees of any company or organization (excluding charitable organizations)?'
            }
            options={trueFalseOptions}
            required
        />
        <BoardMembershipOrganisationSection />
    </div>
);
